export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Masuk",
    "login.form.hint.user": "Login",
    "login.form.hint.password": "Kata sandi",
    "login.form.checkbox.remember-me": "Ingat saya",
    "login.form.button.sign-in": "Masuk",
    "login.form.message.invalid-user-credentials": "Kredensial login atau kata sandi salah",
    "login.form.message.user-required": "Masukkan kredensial login",
    "login.form.message.password-required": "Masukkan Kata sandi",
    "login.form.button.forgot-password": "Lupa kata sandi?",
    "error.root-admin-login.title": "Kesalahan 403 – terlarang",
    "error.root-admin-login.message": "Anda masuk sebagai Administrator Hanya Baca. Untuk mengakses konsol Web Recovery, silakan masuk sebagai pengguna penyewa pelanggan atau administrator"
};
